import React, { useContext, useMemo } from "react";
import { useTextDomainContext, useUser } from "@/app/providers";
import { usePageTitle, useCompanyBuildings } from "@/hooks";
import { useLocation, useParams } from "react-router";
import { TableView1, BackButton } from "@/components";
import type { BuildingMetersType } from "@/types/graphql";
// import { MeterRow, MeterAction } from "./types";

type EnergyTypeKey = "electricity" | "energy" | "gas" | "heating" | "water";

export const MeterList = () => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const location = useLocation();
  // const navigate = useNavigate();

  const {
    companyId: parmsCompanyId = "",
    customerId: paramsCustomerId = "",
    childCompanyId: paramsChildCompanyId = "",
    energyType = "",
  } = useParams();

  const { user } = useUser();
  const customerId =
    paramsCustomerId || parmsCompanyId || user?.currentTeamId || "";
  const subsidiaryId = paramsChildCompanyId || user?.currentSubsidiaryId || "";

  const variables = {
    customerId,
    subsidiaryId,
  };

  const { buildings, loading } = useCompanyBuildings(variables);

  usePageTitle(gettext("Meter List"));

  // const showItems = useMemo(
  //   () => {
  //     return {
  //       // showAdd: (props.showAdd && allowCompaniesFull) ?? false,
  //       // showEdit: (props.showEdit && allowCompaniesFull) ?? false,
  //       // showUnlink: (props.showUnlink && allowCompaniesFull) || !!tenantId,
  //       // showDelete: (props.showDelete && allowCompaniesFull) ?? false,
  //       // showChildCompanies: allowCompaniesReadonly,
  //     };
  //   },
  //   [
  //     // props.showAdd,
  //     // props.showDelete,
  //     // props.showEdit,
  //     // props.showUnlink,
  //     // tenantId,
  //   ],
  // );

  const displayEnergyType = (energyType ||
    location.state?.filter ||
    "electricity") as EnergyTypeKey;

  const targetLocation = useMemo(() => {
    return buildings?.find(
      (b: BuildingMetersType) => b.address === location.state?.locationAddress,
    );
  }, [buildings, location.state?.locationAddress]);

  const rows = useMemo(() => {
    if (!targetLocation) return [];
    const list = targetLocation[displayEnergyType] || [];
    return (list as Array<any>).map((item: any, index: number) => ({
      ...item,
      id: item.meterNo || item.id || `meter-${index}`,
    }));
  }, [targetLocation, displayEnergyType]);

  const initialState = {
    pagination: {
      paginationModel: { page: 0, pageSize: 100 },
    },
  };

  const columns = [
    {
      field: "label",
      headerName: gettext("Label"),
      flex: 1,
    },
    {
      field: "meterNo",
      headerName: gettext("Meter No"),
      flex: 1,
    },
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: gettext("Actions"),
    //   hideable: false,
    //   maxWidth: 75,
    //   align: "right",
    //   headerAlign: "right",
    //   // renderCell: (params) => columnFormatter(params),
    //   renderCell: (params: GridRenderCellParams<MeterRow>) => (
    //     <ActionMenu
    //       menuFor="meter"
    //       row={params.row}
    //       menuClick={menuClick}
    //       showItems={showItems}
    //     />
    //   ),
    // },

    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: gettext("Actions"),
    //   hideable: false,
    //   maxWidth: 75,
    //   align: "right",
    //   headerAlign: "right",
    //   renderCell: (params: any) => (
    //     <ActionMenu
    //       menuFor="meter"
    //       row={params.row}
    //       menuClick={(_action, row) => {
    //         navigate(`${location.pathname}/${row.meterNo || row.id}/data`, {
    //           state: {
    //             meterNo: row.meterNo,
    //             label: row.label,
    //             energyType: displayEnergyType,
    //             locationAddress: targetLocation?.address,
    //             parentPath: location.pathname,
    //           },
    //         });
    //       }}
    //     />
    //   ),
    // },
  ];

  // const menuClick = (action: MeterAction, row: MeterRow) => {
  //   switch (action) {
  //     // case "company-child-companies":
  //     //   navigate(
  //     //     parmsTenantId
  //     //       ? `/${parentPath}/tenants/${tenantId}/companies/${row?.id}/child-companies`
  //     //       : `/${parentPath}/companies/${row?.id}/child-companies`,
  //     //     {
  //     //       state: {
  //     //         parentPath: location.pathname,
  //     //       },
  //     //     },
  //     //   );
  //     //   break;
  //     case "meter-unlink":
  //       // setConfirmMessage(gettext("Do you want to unlink the company?"));
  //       // handleOnClickRemoveLink(action, row?.id);
  //       row;
  //       break;
  //     default:
  //       break;
  //   }
  // };

  return (
    <>
      <TableView1
        title={`${gettext("Meter List")} - ${gettext(
          displayEnergyType.charAt(0).toUpperCase() +
            displayEnergyType.slice(1),
        )}`}
        postToolbar={<BackButton />}
        // postToolbar={<>{!!location.state?.parentPath && <BackButton link={`${location.state?.parentPath}`} />}</>}
        rows={rows}
        columns={columns as any}
        loading={loading}
        showGridToolbar
        showGridToolbarQuickFilter
        initialState={initialState}
      />
    </>
  );
};
